export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Auth/LoginPage.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/thank-you",
    name: "thank-you",
    component: () => import("@/views/ThankYouPage.vue"),
    meta: {
      layout: "auth",
    },
  },
];
